import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { EApplicationEnvironments } from './app/core/configurations/application.config';
import { environment } from './environments/environment';

if (environment.application_environment === EApplicationEnvironments.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(console.error);
